import { Injectable, OnDestroy } from "@angular/core";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { Customer, POSTable_Item, req_ChangePaymentSelect, ChangePaymentSelectChangeType, PaymentItem, TableData, ChangePaymentSelectStatus, Table, StartPaymentSelectStatus, AbortPaymentSelectStatus } from "../../services/IInHouseOrderService";

import { WebShopService } from "../../services/webShop.service";
import Utils from "../../shared/utils";
import { IInhousePaymentOrderService, ISeatOrder, IItemSortOption, ISeatOrderItem } from "./inHousePaymentOrder.facade";
import { CoreLogService } from "../../services/log.service";
import { BehaviorSubject, Observable, Subscription, Subject } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WarningdialogComponent } from "../../modalDialogs";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";

class ItemSortOption implements IItemSortOption {
  //#region IItemSortOption Interface
  get langkey(): string {
    return this._langkey;
  }
  get selected(): boolean {
    return this._isSelected;
  }
  sortBy() {
    const me = this;
    me.sort();
    me._done(me);
  }
  //#endregion

  private _langkey: string;
  private _isSelected: boolean;

  /** interen, möglichkeit  zum ändern der selection */
  public changeSelected(selected: boolean): void {
    this._isSelected = selected;
  }

  constructor(langkey: string, preSelect: boolean, sort: () => void, done: (option: ItemSortOption) => void) {
    const me = this;
    me._langkey = langkey;
    me._isSelected = preSelect;
    me._sort = sort;
    me._done = done;
  }

  private _sort: () => void;
  public sort(): void {
    this._sort();
  }

  private _done: (option: ItemSortOption) => void;
}

class SeatOrder implements ISeatOrder {
  //#region ISeatOrder interface 
  public get id(): number {
    const me = this;
    if (me.cusDataModel)
      return me.cusDataModel.place_no;
    else
      return 0;
  }

  public get isSelected(): boolean {
    const me = this;
    // ermitteln, das alle subelemente markiert sind
    for (let i = 0; i < me.items.length; i++) {
      const item = me.items[i];
      if (!item.isLockedForPayment && item.count != item.selectedCount) {
        return false; // break here
      }
    }
    return true;
  }

  public get isLockedForPayment(): boolean {
    const me = this;
    // ermitteln, das alle subelemente markiert sind
    for (let i = 0; i < me.items.length; i++) {
      const item = me.items[i];
      if (!item.isLockedForPayment) {
        return false; // break here
      }
    }
    return true;
  }

  public get name(): string {
    const me = this;
    if (me.cusDataModel)
      return me.cusDataModel.nickname;
    else
      return "";
  }
  public get isGuest(): boolean {
    const me = this;
    if (me.cusDataModel)
      return me.cusDataModel.guest;
    else
      return true;
  }
  public get seat(): number {
    const me = this;
    if (me.cusDataModel)
      return me.cusDataModel.place_no;
    else
      return null;
  }
  public items: SeatOrderItem[] = [];
  public toggleSelection(select: boolean) {
    const me = this;
    const changeItems = me.prepareToggleSelection(select);
    if (changeItems.length > 0) {
      me.owner.changeItemsSelection(changeItems);
    }
  }
  //#endregion

  public constructor(owner: InhousePaymentOrderService, cusDataModel: Customer | null) {
    const me = this;
    me.owner = owner;
    me.cusDataModel = cusDataModel;
  }

  /** referenz auf den owner, InhousePaymentOrderService um Selectionen ausführen zu können */
  private owner: InhousePaymentOrderService;
  /** referenz auf den customer, wenn null, dan ohne zuordnung */
  private cusDataModel: Customer;

  /** hilfsfunktion initial Item, hinzuzufügen */
  public addSelectedItem(itemDataModel: POSTable_Item, itemCount: number, itemCountSelected: number): void {
    this.items.push(new SeatOrderItem(this, itemDataModel, false, itemCount, itemCountSelected));
  }
  /** hilfsfunktion initial Item, hinzuzufügen */
  public addLockedItem(itemDataModel: POSTable_Item, itemCount: number): void {
    this.items.push(new SeatOrderItem(this, itemDataModel, true, itemCount, 0));
  }

  /** userToken vom customer sonst "" */
  public get userToken(): string {
    const me = this;
    if (me.cusDataModel)
      return me.cusDataModel.user_token;
    else
      return "";
  }

  /** hilfsfunktion für das Item, die eigene selection zu verändern */
  public changeItemSelection(change: PaymentItem): any {
    this.owner.changeItemsSelection([change]);
  }

  /** bereitet ein ToggleSelect vor ohne es auf dem Server auszulösen */
  public prepareToggleSelection(select: boolean): Array<PaymentItem> {
    const me = this;
    const changeItems = new Array<PaymentItem>();
    me.items.forEach(item => {
      const itemChange = item.prepareToggleSelection(select);
      if (itemChange) {
        changeItems.push(itemChange);
      }
    });
    return changeItems;
  }
}

class SeatOrderItem implements ISeatOrderItem {
  //#region ISeatOrderItem interface 
  public get id(): string | number {
    return this.itemDataModel.id.toString() + this.itemIsLocked.toString(); // (getrennt von item, da es durch itemIsLocked getrennt wird)
  }
  public get isSelected(): boolean {
    return (!this.itemIsLocked) && this.selectedCount > 0;
  }
  public get isLockedForPayment(): boolean {
    return this.itemIsLocked;
  }
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.itemDataModel.name_en) ? this.itemDataModel.name_de : this.itemDataModel.name_en;
  }
  public get count(): number {
    return this.itemCount;
  }
  public get selectedCount(): number {
    return this.itemCountSelected;
  }
  public get price(): number {
    const me = this;
    if (me.selectedCount > 0) {
      return Utils.centsToCurrency(me.itemDataModel.price * me.selectedCount);
    } else {
      return Utils.centsToCurrency(me.itemDataModel.price * me.itemDataModel.amount);
    }
  }
  public toggleSelection(select: boolean) {
    const me = this;
    const changeItem = me.prepareToggleSelection(select);
    if (changeItem) {
      me.owner.changeItemSelection(changeItem);
    }
  }
  public increment() {
    const me = this;
    if (me.itemCount > me.itemCountSelected) {
      // increment by 1
      me.itemCountSelected += 1; // für UI anpassen
      me.owner.changeItemSelection({ id: me.itemDataModel.id, prod_id: me.itemDataModel.productID, amount: 1 });
    }
  }
  public decrement() {
    const me = this;
    if (me.itemCountSelected > 0) {
      // decrement by 1
      me.itemCountSelected += -1; // für UI anpassen
      me.owner.changeItemSelection({ id: me.itemDataModel.id, prod_id: me.itemDataModel.productID, amount: -1 });
    }
  }
  //#endregion

  public constructor(owner: SeatOrder, itemDataModel: POSTable_Item, itemIsLocked: boolean, itemCount: number, itemCountSelected: number) {
    const me = this;
    me.owner = owner;
    me.itemDataModel = itemDataModel;
    me.itemIsLocked = itemIsLocked;
    me.itemCount = itemCount;
    me.itemCountSelected = itemCountSelected;
  }

  /** referenz auf den owner, SeatOrder um Selectionen ausführen zu können */
  private owner: SeatOrder;
  /** referenz auf den bestellten artikel */
  private itemDataModel: POSTable_Item;
  /** referenz auf den bestellten artikel */
  public get ItemDataModel(): POSTable_Item {
    return this.itemDataModel;
  }
  /** Artikel ist in Zahlung dur andren Gast */
  private itemIsLocked: boolean;
  /** Srtikel Anzahl (getrennt von item, da es durch itemIsLocked getrennt wird) */
  private itemCount: number;
  /** ausgewählte Artikel Anzahl (getrennt von item, da es durch itemIsLocked getrennt wird) */
  private itemCountSelected: number;

  /** bereitet ein ToggleSelect vor ohne es auszulösen, wenn keine änderung wird NULL returnt */
  public prepareToggleSelection(select: boolean): PaymentItem {
    const me = this;
    if (!me.itemIsLocked) {
      if (select) {
        if (me.itemCount != me.itemCountSelected) {
          const changeItemCount = me.itemCount - me.itemCountSelected;
          me.itemCountSelected += changeItemCount; // für UI anpassen
          return { id: me.itemDataModel.id, prod_id: me.itemDataModel.productID, amount: changeItemCount };
        }
      } else {
        if (me.itemCountSelected > 0) {
          const changeItemCount = -me.itemCountSelected; // '-' (minus) to remove
          me.itemCountSelected += changeItemCount; // für UI anpassen
          return { id: me.itemDataModel.id, prod_id: me.itemDataModel.productID, amount: changeItemCount };
        }
      }
    }
    return null;
  }

  /** interne funktion um den selection zu ändern */
  public changeSelectedCount(newCount: number): void {
    this.itemCountSelected = newCount;
  }
}

@Injectable()
export class InhousePaymentOrderService implements IInhousePaymentOrderService, OnDestroy {

  //#region properties

  /** nicht ändern siehe _set*() */
  private _tableNo: string = "";
  private setTableNo(tableNo: string): void {
    const me = this;
    if (me._tableNo != tableNo) {
      me._tableNo = tableNo;
      me._tableNoSubject.next(me._tableNo);
    }
  }
  private _tableNoSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public get tableNo$(): Observable<string> {
    return this._tableNoSubject.asObservable();
  }

  private _orders: SeatOrder[] = [];

  private _ordersSubject: BehaviorSubject<ReadonlyArray<ISeatOrder>> = new BehaviorSubject<ReadonlyArray<ISeatOrder>>([]);
  public get orders$(): Observable<ReadonlyArray<ISeatOrder>> {
    return this._ordersSubject.asObservable();
  }

  /** nicht ändern siehe _set*() */
  private _sum: number = 0;
  private _setSum(sum: number): void {
    const me = this;
    if (me._sum != sum) {
      me._sum = sum;
      me._sumSubject.next(me._sum);
      me.recountPrice();
    }
  }
  private _sumSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  /** anzahl gewählter items */
  public get sum$(): Observable<number> {
    return this._sumSubject.asObservable();
  }

  /** nicht ändern siehe constructor() und setTippingPercent() */
  private _tippingPercent: number = 0;
  private _tippingPercentSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get tippingPercent$(): Observable<number> {
    return this._tippingPercentSubject.asObservable();
  }

  /** nicht ändern siehe recountPrice() */
  private _tippingAmount: number = 0;
  private _tippingAmountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get tippingAmount$(): Observable<number> {
    return this._tippingAmountSubject.asObservable();
  }

  /** nicht ändern siehe recountPrice() */
  private _total: number = 0;
  private _totalSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get total$(): Observable<number> {
    return this._totalSubject.asObservable();
  }

  /** tip wird al prozent oder amount representiert */
  private _tipAsPercent: boolean = true;

  /** bestimmt erneut die Summen der preise */
  private recountPrice(): void {
    const me = this;
    if (me._tipAsPercent) {
      me._tippingAmount = Utils.moneyRound(me._sum * ((me._tippingPercent / 100)));
      me._tippingAmountSubject.next(me._tippingAmount);
    } // else keep and use tippingAmount
    me._total = me._sum + me._tippingAmount;
    me._totalSubject.next(me._total);
    me._setCanContinue(me._total > 0);
  }

  private _showTipping: boolean;
  public get showTipping(): boolean {
    return this._showTipping;
  }

  private _sortOptions: Array<ItemSortOption> = [];
  private _sortOptionsSubject: BehaviorSubject<ReadonlyArray<IItemSortOption>> = new BehaviorSubject<ReadonlyArray<IItemSortOption>>([]);
  public get sortOptions$(): Observable<ReadonlyArray<IItemSortOption>> {
    return this._sortOptionsSubject.asObservable();
  }

  private _activityTriggerdSubject: Subject<void> = new Subject<void>();
  public get activityTriggerd$(): Observable<void> {
    return this._activityTriggerdSubject.asObservable();
  }

  /** nicht ändern siehe _set*() */
  private _canContinue: boolean = false;
  private _setCanContinue(canContinue: boolean): void {
    const me = this;
    if (me._canContinue != canContinue) {
      me._canContinue = canContinue;
      me._canContinueSubject.next(me._canContinue);
    }
  }
  private _canContinueSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get canContinue$(): Observable<boolean> {
    return this._canContinueSubject.asObservable();
  }

  public get groupName(): string {
    return this._inHouseOrderService.GroupName;
  }

  private _reconnectingSubscrition: Subscription;
  private _reconnectedSubscrition: Subscription;
  private _closedSubscrition: Subscription;
  private _onTableChangedSubscrition: Subscription;

  //#endregion

  constructor(
    private _inHouseOrderService: InHouseOrderService,
    private _webShopService: WebShopService,
    private _coreLogService: CoreLogService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _router: Router,
    private _MatDialog: MatDialog,
  ) {
    const me = this;
    me._initSortOptions();
    me._showTipping = me._webShopService.ordertype ? me._webShopService.isTippingEnabled() : false;
    if (me._showTipping) {
      me.setTippingPercent(me._webShopService.ordertype ? me._webShopService.ordertype.tip_percentage : 0);
    }

    me.setTableNo(me._inHouseOrderService.UiData.table_no);

    //me._reconnectingSubscrition = me._inHouseOrderService.ObserveReconnecting.subscribe(() => {
    //  // verarbeitung momentan nicht möglich verbindung nicht möglich
    //  //!Mark wird bearbeitet
    //});

    //me._reconnectedSubscrition = me._inHouseOrderService.ObserveReconnected.subscribe(() => {
    //  // verarbeitung kann fortgesetzt werden
    //  // Info, da sich Daten verändert haben könnten, ruft InHouseOrderService intern an abruf durch und triggert OnTableChanged
    //   //!Mark wird bearbeitet
    //});

    me._closedSubscrition = me._inHouseOrderService.ObserveClosed.subscribe(() => {
      // fehler verbindung konnte nicht wieder hergestellt werden
      //!Mark wird bearbeitet
      // Reconnecting failed info dialog
      me.OpenReconnectFaildInfoDialog();
      me._router.navigateByUrl("/"); //home
    });

    me._onTableChangedSubscrition = me._inHouseOrderService.ObserveOnTableChanged.subscribe(() => {
      me.bindNewTableData(); // no wait
    });
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;

    if (me._reconnectingSubscrition)
      me._reconnectingSubscrition.unsubscribe();
    if (me._reconnectedSubscrition)
      me._reconnectedSubscrition.unsubscribe();
    if (me._closedSubscrition)
      me._closedSubscrition.unsubscribe();
    if (me._onTableChangedSubscrition)
      me._onTableChangedSubscrition.unsubscribe();
  }

  private OpenReconnectFaildInfoDialog() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_LostConnection_Title"
        , content: "phInHouse_LostConnection_Description"
        , btnLabel: "phInHouse_Continue_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  /** bindet sich an die Table Daten
   * @param force Erzwingt das Abrufen der Daten vom Server
   */
  private bindNewTableData(force: boolean = false): Promise<void> {
    const me = this;
    return new Promise<void>(async (resolve, reject) => {
      try {
        const table = await me._inHouseOrderService.GetTable(force ? TableData.All : null); // null damit kein unnötiger Abruf stattfindet
        const newOrders = me.getOrdersFromTable(table);
        // sortierung, myOrder first, ohne zuordnung last, sonst nach Platz
        const userToken = me._inHouseOrderService.UserToken;
        newOrders.sort((left, right) => {
          if (left.userToken == userToken || right.userToken == "") {
            return -1;
          } else if (right.userToken == userToken || left.userToken == "") {
            return 1;
          } else if (left.seat < right.seat) {
            return -1;
          } else if (left.seat > right.seat) {
            return 1;
          }
          // else left.seat == right.seat // sollte aber nicht sein
          return 0;
        });

        me.checkDifferenceInOrders(me._orders, newOrders);

        me._orders = newOrders;
        const sortOption = me._sortOptions.find((option) => option.selected);
        if (sortOption)
          sortOption.sort();
        me._ordersSubject.next(me._orders);
        me.recalcSum();
        resolve();
      } catch (error) {
        // todo womöglich sollte die ui neu aufgerufen werden
        me._coreLogService.error("InhousePaymentOrderService.bindNewTableData", "catch", error);
        reject(error);
      }
    });
  }

  /** wandelt Table zu SeatOrders für die UI um */
  private getOrdersFromTable(table: Table): Array<SeatOrder> {
    const me = this;
    const seats = me._inHouseOrderService.GetSeatsFromTable(table);
    // laufende Zahlungen auslesen
    const userToken = me._inHouseOrderService.UserToken;
    const newPayments = <{ [id: number]: { userToken: string, payment_item: PaymentItem }[] }>{};
    table.yasTable.payments.forEach(payment => {
      payment.items.forEach(item => {
        if (!newPayments[item.id]) {
          newPayments[item.id] = [];
        }
        newPayments[item.id].push({ userToken: payment.userToken, payment_item: item });
      });
    });
    // new Orders erzeugen
    const newOrders = new Array<SeatOrder>();
    for (const key in seats) {
      if (Object.prototype.hasOwnProperty.call(seats, key)) {
        const seat = seats[key];
        const newOrder = new SeatOrder(me, seat.customer);
        // fülle die Items und trenne die hinaus in zahlung durch andere und markiere die anzahl in zahlung
        seat.pos_items.forEach(pos_item => {
          const payments = newPayments[pos_item.id];
          if (payments) {
            let selectedCount = 0;
            let lockedCount = 0;
            payments.forEach(payment => {
              if (payment.userToken == userToken) {
                selectedCount += payment.payment_item.amount;
              } else {
                lockedCount += payment.payment_item.amount;
              }
            });
            if (pos_item.amount > lockedCount)
              newOrder.addSelectedItem(pos_item, pos_item.amount - lockedCount, selectedCount);
            if (lockedCount > 0)
              newOrder.addLockedItem(pos_item, lockedCount);
          } else {
            newOrder.addSelectedItem(pos_item, pos_item.amount, 0);
          }
        });
        if (newOrder.items.length > 0)
          newOrders.push(newOrder);
      }
    }
    return newOrders;
  }

  /** prüft ob die neue auswahl die aktuelle auswahl einschliesst */
  private checkDifferenceInOrders(currentOrders: Array<SeatOrder>, newOrders: Array<SeatOrder>): void {
    // neue auswahl auslesen
    const newSelection: { [id: number]: number } = {};
    newOrders.forEach(order => {
      order.items.forEach(item => {
        if (item.selectedCount > 0) {
          newSelection[item.ItemDataModel.id] = item.selectedCount;
        }
      });
    });
    // momentane auswahl abziehen, bei negativem wert ist etwas abgewählt worden
    for (let i = 0; i < currentOrders.length; i++) {
      for (let j = 0; j < currentOrders[i].items.length; j++) {
        const item = currentOrders[i].items[j];
        if (!newSelection[item.ItemDataModel.id] || newSelection[item.ItemDataModel.id] < item.selectedCount) {
          // TODO notify user selection is changed
          return; // break here
        }
      }
    }
    // new selection contains current selection
  }

  public async startPaymentSelect(): Promise<boolean> {
    const me = this;
    try {
      const response = await me._inHouseOrderService.StartPaymentSelect();
      if (response.status === StartPaymentSelectStatus.Okay) {
        await me.bindNewTableData(true); // initial refresh all data
        return true;
      } else {
        me._coreLogService.error("InhousePaymentOrderService.startPaymentSelect", "StartPaymentSelect status not Okay", response.status);
        return false;
      }
    } catch (error) {
      me._coreLogService.error("InhousePaymentOrderService.startPaymentSelect", "catch", error);
      return false;
    }
  }

  public async abortPaymentSelect(): Promise<boolean> {
    const me = this;
    try {
      const response = await me._inHouseOrderService.AbortPaymentSelect();
      if (response.status === AbortPaymentSelectStatus.Okay) {
        return true;
      } else {
        me._coreLogService.error("InhousePaymentOrderService.abortPaymentSelect", "AbortPaymentSelect status not Okay", response.status);
        return false;
      }
    } catch (error) {
      me._coreLogService.error("InhousePaymentOrderService.abortPaymentSelect", "catch", error);
      return false;
    }
  }

  public selectAll() {
    const me = this;
    me.toggleSelection(true);
  }

  public selectNone() {
    const me = this;
    me.toggleSelection(false);
  }

  /** toggelt die gesamte selection */
  private toggleSelection(select: boolean): void {
    const me = this;
    const changeItems = new Array<PaymentItem>();
    me._orders.forEach(order => {
      const changeOrderItems = order.prepareToggleSelection(select);
      if (changeOrderItems.length > 0) {
        changeItems.push(...changeOrderItems);
      }
    });
    if (changeItems.length > 0) {
      me.changeItemsSelection(changeItems);
    }
  }

  public selectMyItems() {
    const me = this;
    // am einfachsten ist alle zu entfernen und mit eigenen und ohne zurodnung
    const myUserToken = me._inHouseOrderService.UserToken;
    const changeItems = new Array<PaymentItem>();
    for (let i = 0; i < me._orders.length; i++) {
      const order = me._orders[i];
      if (order.userToken == myUserToken) {
        changeItems.push(...order.prepareToggleSelection(true));
      } else if (order.userToken == "" /* "" = Ohne Zuordnung */) {
        changeItems.push(...order.prepareToggleSelection(true));
      } else /* andere gäste */ {
        changeItems.push(...order.prepareToggleSelection(false));
      }
    }
    if (changeItems.length > 0) {
      me.changeItemsSelection(changeItems);
    }
  }

  /** ermittet erneut die Summe der ausgewählten artikel */
  private recalcSum() {
    const me = this;
    let sum = 0;
    me._orders.forEach(order => {
      order.items.forEach(item => {
        if (item.isSelected)
          sum = Utils.moneyRound(sum + item.price);
      });
    });
    me._setSum(sum);
  }

  /** ermöglicht den items ihr itemCountSelect zu verändern */
  public changeItemsSelection(changeItems: Array<PaymentItem>): void {
    const me = this;
    me._activityTriggerdSubject.next(); // changeItemsSelection ist eine Aktion
    me._ordersSubject.next(me._orders); // ui aktualisieren, daten haben sich bereits aktualisiert
    // server informieren
    const request = new req_ChangePaymentSelect();
    request.change_type = ChangePaymentSelectChangeType.Diff;
    request.items = changeItems;
    request.return_items = false;
    me._inHouseOrderService.ChangePaymentSelect(request).then((response) => {
      if (response.status === ChangePaymentSelectStatus.Okay) {
        me.recalcSum(); // ui ist auf dem aktuellen stand
      } else if (response.status === ChangePaymentSelectStatus.Fail) {
        me.bindNewTableData(true); // refrash ui
      } else { // error
        // todo notify user
        me._coreLogService.error("InhousePaymentOrderService.changeItemsSelection", "ChangePaymentSelect status not Okay", response.status);
        me.retrunToInHauseServiceSelector();
      }
    }).catch((error) => {
      // todo notify user ?
      me._coreLogService.error("InhousePaymentOrderService.changeItemsSelection", "catch", error);
      me.retrunToInHauseServiceSelector();
    });
  }

  /** navigiert zurück zur InHouse Landingpage */
  private retrunToInHauseServiceSelector(): void {
    const me = this;
    me._inHouseOrderService.openInHauseLandingPage();
  }

  public setTippingPercent(percent: number) {
    const me = this;
    if (me._tipAsPercent != true || me._tippingPercent != percent) {
      me._tippingPercent = percent;
      me._tippingPercentSubject.next(me._tippingPercent);
      me._tipAsPercent = true;
      me.recountPrice();
    }
  }

  public setTippingAmount(amount: number) {
    const me = this;
    if (me._tipAsPercent != false || me._tippingAmount != amount) {
      me._tippingAmount = amount;
      me._tipAsPercent = false;
      me.recountPrice();
    }
  }

  public continue() {
    const me = this;
    if (me._canContinue) {
      // todo momentan gibt es keinen normalen weg den tip zu übertragen
      me._webShopService.setFixTrinkgeldAmount(me._tippingAmount);
      // ! momentan wird die navigation im inHausePayment durchgeführt
    } else {
      throw new Error("Can not continue");
    }
  }

  /**
   * Returns true if paying now would close the table for all other participants.
   *
   * Falls back to `true` if the required data is unavailable.
   */
  public paymentClosesTableForOthers(table: Table, payerToken: string): boolean {
    const me = this;
    try {
      if (!payerToken) {
        return true;
      }
      const customers = table && table.yasTable && table.yasTable.customers;
      const items = table && table.posTable && table.posTable.items;
      if (!customers || !items) {
        return true;
      }
      const otherParticipants = customers.filter(c => c.user_token !== payerToken);
      if (otherParticipants.length === 0) {
        return false;
      }
      const anyOtherHasItems = otherParticipants.some(c => {
        if (!c.user_token) { return false; }
        return items.some(item => item.userToken === c.user_token);
      });
      return !anyOtherHasItems;
    } catch {
      return true;
    }
  }

  private _initSortOptions() {
    const me = this;

    /** callback wenn die sortierung erfolgreich war, dabei werden die Orders neu gezeichnet und die auswahl angezeigt */
    const doneCb = (option: ItemSortOption) => {
      me._ordersSubject.next(me._orders);
      me.setSelectedSortOption(option);
    }

    // Orders nach order id (ist Position am POS).
    me._sortOptions.push(new ItemSortOption("phInHouse_Sort_Option_Added", true,
      () => {
        me._orders.forEach(order => {
          order.items.sort((l, r) => { return l.ItemDataModel.id - r.ItemDataModel.id; });
        });
      }, doneCb));

    // Preis aufsteigend
    me._sortOptions.push(new ItemSortOption("phInHouse_Sort_Option_Name", false,
      () => {
        me._orders.forEach(order => {
          order.items.sort((l, r) => { return l.label < r.label ? -1 : (l.label > r.label ? 1 : 0); });
        });
      }, doneCb));

    // Preis aufsteigend
    me._sortOptions.push(new ItemSortOption("phInHouse_Sort_Option_Price_Ascending", false,
      () => {
        me._orders.forEach(order => {
          order.items.sort((l, r) => { return l.price - r.price; });
        });
      }, doneCb));

    // Preis absteigend
    me._sortOptions.push(new ItemSortOption("phInHouse_Sort_Option_Price_Descending", false,
      () => {
        me._orders.forEach(order => {
          order.items.sort((l, r) => { return r.price - l.price; });
        });
      }, doneCb));

    me._sortOptionsSubject.next(me._sortOptions);
  }

  /** ändert den aktuellen filter für die UI */
  private setSelectedSortOption(selectedOption: IItemSortOption) {
    this._sortOptions.forEach((option) => option.changeSelected(option === selectedOption));
    this._sortOptionsSubject.next(this._sortOptions);
  }

}
